









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import SpinnerCore from 'vue-spinner/src/DotLoader.vue'

@Component({
  components: {
    SpinnerCore
  }
})
export default class Spinner extends Vue {
  @Prop({ type: Boolean, default: true }) private loading!: Boolean
  @Prop({ type: String, default: '#2F93FE' }) private color!: String
  @Prop({ type: String, default: '30px' }) private size!: String
  @Prop({ type: String, default: '2px' }) private margin!: String
  @Prop({ type: String, default: '100%' }) private radius!: String
}
